
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class timePopup extends Vue {
  @Prop({ default: '' }) title?: string

  popShow = false
  isShowDatetimePicker = false
  pickerType = 0 // 0初始状态 1开始时间 2结束时间
  picker = {
    startTime: '',
    endTime: ''
  }

  showPop(params) {
    params && (this.picker = params)
    this.popShow = true
  }

  onCancel() {
    this.popShow = false
    this.isShowDatetimePicker = false
    this.pickerType = 0
  }

  onConfirm() {
    const { startTime, endTime } = this.picker
    if (!startTime || !endTime) {
      this.$toast(`请选择${this.title}时间`)
      return
    }
    this.popShow = false
    this.isShowDatetimePicker = false
    this.pickerType = 0
    this.$emit('confirm', this.picker)
  }

  onSelect(type: any) {
    this.isShowDatetimePicker = true
    this.pickerType = type
  }

  onChange(e: any) {
    let val = e.getValues()
    if (this.pickerType == 1) {
      this.picker.startTime = val.join(':')
    } else if (this.pickerType == 2) {
      this.picker.endTime = val.join(':')
    }
  }
}
